import { Injectable } from '@angular/core';

export type InternalStateType = {
  [key: string]: any
};

@Injectable()
export class AppState {
  public ScrollMagic : any;
  public controller : any;
  public controllerMain : any;
  public _state: InternalStateType = { };
  public all_fees : any;

  constructor(){
    this.ScrollMagic = require("scrollmagic");
    require("scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap");
    this.controller = new this.ScrollMagic.Controller();
    this.controllerMain = new this.ScrollMagic.Controller();  
    this.all_fees = {
      tiger: {
        experience_20: "180",
        experience_30: "245",
        experience_40: "310",
        normal: "200"
      },
      cub:{
        normal: "140"
      },
      turb:{
        normal: "75"
      },
      cap:{
        experience_20: "180",
        normal: "200"
      },
      formation:{ 
        normal: "150"
      },
      membership: {
        full: "250",
        overseas: "135",
        temp: "50",
        associate: "50"
      },
      last_updated: "1st January 2017"
    };
   }

  /**
   * Already return a clone of the current state.
   */
  public get state() {
    return this._state = this._clone(this._state);
  }
  /**
   * Never allow mutation
   */
  public set state(value) {
    throw new Error('do not mutate the `.state` directly');
  }

  public get(prop?: any) {
    /**
     * Use our state getter for the clone.
     */
    const state = this.state;
    return state.hasOwnProperty(prop) ? state[prop] : state;
  }

  public getFees() {
    /**
     * Use our state getter for the clone.
     */
    const state = this.all_fees;
    return state;
  }

  public set(prop: string, value: any) {
    /**
     * Internally mutate our state.
     */
    return this._state[prop] = value;
  }

  private _clone(object: InternalStateType) {
    /**
     * Simple object clone.
     */
    return JSON.parse(JSON.stringify( object ));
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/app.service.ts